import "@babel/polyfill";
import xsyxBridge from "@xsyx/bridge";
import { createApp } from "vue";
import VConsole from "vconsole";
import App from "./App.vue";
import router from "./routes";
import api from "@api/index";
import "vant/lib/index.css";
import "@assets/style/global.less";
import { Notify } from "vant";

let vconsole = new VConsole();

try {
  // xsyxBridge.getDeviceInfo({
  //   success: (res) => {
  //     const { statusBarHeight = 20 } = res;
  //     const height = window.sdkEnv !== "web" ? statusBarHeight : 20;
  //     document.body.setAttribute(
  //       "style",
  //       `--var-status-height:${parseFloat(height)}px;`,
  //     );
  //   },
  //   fail: (e) => {
  //     console.log(e);
  //   },
  // });
} catch (e) {
  console.log(e);
}

const app = createApp(App);
const { globalProperties } = app.config;

globalProperties.$api = api;
globalProperties.$notify = Notify;
globalProperties.$xsyxBridge = xsyxBridge;
globalProperties.$rootPx = (document.body.clientWidth || 375) / 375;
globalProperties.$vconsole = vconsole;
app.use(router);
if (
  process.env.VUE_APP_ENV === "prod" &&
  process.env.NODE_ENV === "production" &&
  window.sdkEnv === "web" &&
  !window.location.hash.includes("/downloadPage") &&
  !window.location.hash.includes("/d") &&
  !window.location.hash.includes("/sharePage")
) {
  document.getElementById("app").innerText = "请在应用内进行访问";
} else {
  app.mount("#app");
}
